import React from 'react';

interface PlaylistCardProps {
  title: string;
  icon: string;
  count: number;
  duration: string;
  link: string;
  onClick?: () => void | Promise<void>;
}

export default function PlaylistCard({ title, icon, count, duration, link, onClick }: PlaylistCardProps) {
  // Handler: analytics update async di background, UX instan
  const handleClick = () => {
    if (onClick) {
      onClick(); // async, tidak di-await
    }
    // Link langsung terbuka
  };
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none' }}
      className="w-full h-full"
      onClick={onClick ? handleClick : undefined}
    >
      <div
        className={
          `rounded-2xl shadow-glass flex flex-col items-center justify-center aspect-square w-full h-full bg-white/40 dark:bg-[#232634]/60 border border-[#e0d7d2]/40 dark:border-[#45475a]/60 backdrop-blur-md transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl card mx-auto px-4 py-5 md:px-6 md:py-7`
        }
        style={{ boxSizing: 'border-box' }}
      >
        <span className="text-4xl md:text-5xl mb-1 md:mb-2">{icon}</span>
        <h2 className="text-xl md:text-2xl font-bold text-center mb-1 md:mb-2 text-[#232634] dark:text-[#f9e2af] font-display tracking-tight leading-tight">{title}</h2>
        <div className="card-info text-sm md:text-base font-medium text-[#6c6f85] dark:text-[#a6adc8] text-center mb-1">
          {count} songs • {duration}
        </div>
      </div>
      <style>{`
        @media (max-width: 640px) {
          .card {
            width: 90vw !important;
            max-width: 320px !important;
            min-width: 140px !important;
            aspect-ratio: 1/1 !important;
            margin-left: auto !important;
            margin-right: auto !important;
            margin-top: 3.5rem !important;
            padding-left: 4px !important;
            padding-right: 4px !important;
            padding-top: 10px !important;
            padding-bottom: 10px !important;
          }
          .card h2 {
            font-size: 1.25rem !important; /* text-2xl */
            margin-bottom: 0.5rem !important;
          }
          .card .card-info {
            font-size: 1rem !important; /* text-base */
          }
        }
        @media (min-width: 641px) and (max-width: 1024px) {
          .card {
            min-width: 180px !important;
            max-width: 320px !important;
            padding-left: 18px !important;
            padding-right: 18px !important;
            padding-top: 24px !important;
            padding-bottom: 24px !important;
          }
        }
      `}</style>
    </a>
  );
}
